import WikiArticleView from "./WikiArticleView";

import "./WikiArticleView.scss";

export * from "./WikiArticleView.types";

export { WikiArticleView };
